'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useGetTenantNameByHostnameQuery } from '@cntxt/data-access/user';
import { isRegisteredKeycloakTenantId } from '@cntxt/shared/infrastructure/keycloak';
import { signIn, useSession } from '@cntxt/shared/infrastructure/session';
import { useHostname } from '@cntxt/shared/utilities/hooks';
import { SignInBlockedAlert } from '../../../../../components/SignInBlockedAlert';
import { getOAuthRedirectTargetUrl } from '../../../../../lib/getOAuthRedirectTargetUrl';
import { reportUnexpectedSignInRejection } from '../../../../../lib/signInExpectedFetchAbort';
import { useSignInLoopGuard } from '../../../../../lib/useSignInLoopGuard';
import Loading from '../../../loading';
export const RedirectToKeycloak = () => {
  const $ = _c(14);
  const session = useSession();
  const hostname = useHostname();
  const {
    allowSignIn,
    markSignedIn
  } = useSignInLoopGuard();
  let t0;
  if ($[0] !== hostname) {
    t0 = {
      hostname
    };
    $[0] = hostname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: provider,
    isError: tenantLookupFailed
  } = useGetTenantNameByHostnameQuery(t0);
  const invalidProvider = typeof provider === "string" && !isRegisteredKeycloakTenantId(provider);
  let t1;
  let t2;
  if ($[2] !== allowSignIn || $[3] !== markSignedIn || $[4] !== provider || $[5] !== session.status) {
    t1 = () => {
      if (session.status === "authenticated") {
        markSignedIn();
        return;
      }
      if (session.status !== "unauthenticated" || typeof provider !== "string") {
        return;
      }
      if (!isRegisteredKeycloakTenantId(provider)) {
        return;
      }
      if (!allowSignIn()) {
        return;
      }
      signIn(provider, {
        redirectTo: getOAuthRedirectTargetUrl()
      }).catch(_temp);
    };
    t2 = [session.status, provider, allowSignIn, markSignedIn];
    $[2] = allowSignIn;
    $[3] = markSignedIn;
    $[4] = provider;
    $[5] = session.status;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  if (tenantLookupFailed) {
    let t3;
    if ($[8] !== hostname) {
      t3 = <SignInBlockedAlert variant="tenant_hostname_lookup_failed" hostname={hostname} context="RedirectToKeycloak" layout="signIn" />;
      $[8] = hostname;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (invalidProvider) {
    let t3;
    if ($[10] !== hostname || $[11] !== provider) {
      t3 = <SignInBlockedAlert variant="tenant_not_in_keycloak_allowlist" hostname={hostname} resolvedTenantId={provider} context="RedirectToKeycloak" layout="signIn" />;
      $[10] = hostname;
      $[11] = provider;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Loading />;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
function _temp(error) {
  reportUnexpectedSignInRejection("RedirectToKeycloak", error);
}